import CircularProgress from '@mui/material/CircularProgress'

import './style.scss'

import { app } from 'actions/app.js'
import { contacts } from 'actions/contacts.js'
import { mapping } from 'actions/mapping.js'
import { api } from 'api/api.js'
import { contactsPageSize } from 'api/contactsPageSize.js'
import clsx from 'clsx'
import FilterNavigation from 'components/molecules/filterNavigation/index.js'
import ModalWindow from 'components/molecules/ModalWindow/index.js'
import TableUsers from 'components/molecules/TableUsers/index.js'
import NoContactsYetTemplate from 'components/templates/noContactsYetTemplate/index.js'
import { NoContactsFound } from 'components/templates/NoSearchResult'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { appActions } from 'redux/reducers/app.ts'
import { notifyError } from 'shared/errors/notificate.ts'
import {
	useActionCreators,
	useAppDispatch,
	useAppSelector
} from 'shared/hooks/index.ts'

import Filters from '../filters/index.js'

export function AddContactsModal(props: {
	checkboxs: boolean
	classesTableContainer: string
	contactsPage: any
	from: 'single-contacts'
	// TODO: check child component to reduce prop drill
	history: any
	isIconActiveModal: any
	match: any
	setActiveFilterIconModal: any
	showSteps: boolean
	type: 'add-to-campaign'
}) {
	const campaignId = useParams<{ id: string }>().id

	const [contactsData, setContactsData] = useState([])
	const [contactsCount, setContactsCount] = useState<null | number>(null)
	const [tableContentLoader, setTableContentLoader] = useState(true)
	const [filtersController, setFiltersController] = useState(false)
	const [isFilterApplied, setIsFilterApplied] = useState(true)
	const [page, setPage] = useState(0)
	const [clearFilterData, setClearFilterData] = useState(false)
	const [isRerender, setIsRerender] = useState(false)
	const [isError, setIsError] = useState<boolean | null>(null)
	const [showAll, setShowAll] = useState(false)
	const [keywords, setKeywords] = useState('')
	const [isFilteringModal, setIsFilteringModal] = useState('imported desc')

	const [initialValuePagination, setInitialValuePagination] = useState(
		contactsPageSize.get()
	)
	const { changePageModalLoader } = useActionCreators(appActions)

	const filters = useAppSelector(state => state.filters),
		isOpen = useAppSelector(state => state.contacts.isModalVisible),
		loader = useAppSelector(state => state.app.pageModalLoader),
		name = useAppSelector(state => state.campaign.name)

	const dispatch = useAppDispatch()

	// biome-ignore lint/correctness/useExhaustiveDependencies: Legacy
	useEffect(() => {
		const lengthFilter = Boolean(
			filters.filterDataForModal.find(
				({ value }) =>
					Array.isArray(value) && value.length > 0 && value[0]?.value
			) || keywords
		)
		setIsFilterApplied(lengthFilter)
	}, [contactsCount])

	const getContactsAsync = async () => {
		try {
			if (campaignId) {
				const filter = filters.filtersQueryForModal
					? filters.filtersQueryForModal
					: `not (campaigns/any(c:c eq '${campaignId}'))`
				const data = {
					filter,
					keywords,
					orderby: isFilteringModal ? isFilteringModal : 'imported desc',
					skip: 0,
					take: initialValuePagination
				}
				await getContacts(data)
			}
		} catch (error) {
			setIsError(true)
			notifyError(error)
		}
	}

	// biome-ignore lint/correctness/useExhaustiveDependencies: Legacy
	useEffect(() => {
		if (isOpen) {
			getContactsAsync()
			setIsRerender(true)
		}
	}, [isOpen])

	// biome-ignore lint/correctness/useExhaustiveDependencies: Legacy
	useEffect(() => {
		if (isRerender) {
			getContactsBySort()
		}
	}, [isFilteringModal])

	// biome-ignore lint/correctness/useExhaustiveDependencies: Legacy
	useEffect(() => {
		if (contactsCount) {
			handleChangePage(undefined, 0)
		}
	}, [initialValuePagination])

	const getContactsBySort = () => {
		contacts.changeContactsPageModal(0)
		return getContacts({
			filter:
				filters.filtersQueryForModal ||
				`not (campaigns/any(c:c eq '${campaignId}'))`,
			keywords,
			orderby: isFilteringModal || 'imported desc',
			take: initialValuePagination
		})
	}

	const getContacts = async (data: any) => {
		try {
			changePageModalLoader(true)
			const response = (await api.getContactsApi(data)) as any

			if (response.status === 200) {
				setContactsData(mapping.buildContacts(response.data.documents))
				setContactsCount(response.data.total)
				if (response.data) {
					if (response.data.documents.length > 0) {
						dispatch({
							payload: {
								contactsCountModal: response.data.total
							},
							type: 'CONTACTS_COUNT_MODAL'
						})
					}
					dispatch({
						payload: {
							contactsModal: mapping.buildContacts(response.data.documents)
						},
						type: 'ALL_CONTACTS_MODAL'
					})
				}
			} else {
				setContactsData([])
				setContactsCount(0)
				contacts.haveContacts(true)
				dispatch({
					payload: {
						contactsCountModal: 0
					},
					type: 'CONTACTS_COUNT_MODAL'
				})
				dispatch({
					payload: {
						contactsModal: []
					},
					type: 'ALL_CONTACTS_MODAL'
				})
			}
			response.data.documents.length === 0
				? changePageModalLoader(false)
				: setTimeout(() => {
						changePageModalLoader(false)
					}, 200)
		} finally {
			setTableContentLoader(false)
			app.changePageContentLoaderStatus(false)
			app.changeTableContentLoaderStatus(false)
		}
	}

	const handleChangePage = (_: unknown, newPage: number) => {
		try {
			setPage(newPage)
			if (campaignId) {
				if (props.type === 'add-to-campaign') {
					const filter =
						filters.filtersQueryForModal ||
						`not (campaigns/any(c:c eq '${campaignId}'))`
					return getContacts({
						filter,
						keywords: keywords || '',
						orderby: isFilteringModal || 'imported desc',
						skip: newPage > 0 ? newPage * initialValuePagination : 0,
						take: initialValuePagination
					})
				}
			}
		} catch (error) {
			notifyError(error)
		}
	}

	const loaderOrHasContacts =
		tableContentLoader || (contactsCount !== null && contactsCount > 0)

	return (
		<ModalWindow
			classes='add-contacts-modal'
			closeHandler={() => {
				dispatch({
					payload: {
						isModalVisible: false
					},
					type: 'IS_MODAL_VISIBLE'
				})
			}}
			open={isOpen}
		>
			<div className='add-contacts-modal-wrapper'>
				<div className='hint-tooltip-wrapper'>
					<div className='add-contacts-modal__header'>
						<span className='add-contacts-modal__headline'>{name}</span>
						<span className='add-contacts-modal__separator' />
						<span className='add-contacts-modal__title'>Add more contacts</span>
					</div>
					{(loaderOrHasContacts || isFilterApplied || isError) && (
						<FilterNavigation
							activeImportId={campaignId}
							clearFilterController={setClearFilterData}
							filters={filters}
							filtersController={filtersController}
							filtersControllerToggle={() =>
								setFiltersController(!filtersController)
							}
							filtersQueryForModal={filters.filtersQueryForModal}
							from={'addToCampaignOfModal'}
							getContacts={getContacts}
							keywords={keywords}
							pageHandler={setPage}
							setKeywords={setKeywords}
							setShowAll={setShowAll}
							showAll={showAll}
						/>
					)}
					{(tableContentLoader || loader) && (
						<div className='material-loader-wrapper-modal'>
							<CircularProgress
								classes={{ colorPrimary: 'material-loader' }}
								color='primary'
								size={60}
							/>
						</div>
					)}
					{(loaderOrHasContacts || isError) && (
						<TableUsers
							activeImportId={props.match.params.id}
							checkboxs={true}
							classesContainer={'contacts-container'}
							contacts={contactsData}
							filters={filters}
							from={props.from}
							getContacts={getContacts}
							history={props.history}
							isFiltering={isFilteringModal}
							isIconActive={props.isIconActiveModal}
							keywords={keywords}
							match={props.match}
							setActiveFilterIcon={props.setActiveFilterIconModal}
							setInitialValuePagination={setInitialValuePagination}
							setIsFiltering={setIsFilteringModal}
							setPage={setPage}
							showSteps={false}
							type='add-to-campaign'
						/>
					)}

					{!tableContentLoader &&
						contactsCount === 0 &&
						!isError &&
						(isFilterApplied ? (
							<NoContactsFound />
						) : (
							<NoContactsYetTemplate handlerExportModal={console.log} isModal />
						))}
				</div>
				<div
					className={clsx('filters-modal', {
						hide: !filtersController
					})}
				>
					<div className='filters-modal__wrapper'>
						<Filters
							clearFilterController={setClearFilterData}
							clearFilterData={clearFilterData}
							filtersControllerByParams={setFiltersController}
							filtersControllerToggle={() =>
								setFiltersController(!filtersController)
							}
							from={'addToCampaignOfModal'}
							getContacts={getContacts}
							keywordsForModal={keywords}
							loadHandlerForModal={setTableContentLoader}
							orderby={isFilteringModal}
							page={page}
							pageHandler={setPage}
							show={filtersController}
						/>
					</div>
				</div>
			</div>
		</ModalWindow>
	)
}
